import { isEmpty } from "lodash";

export const USER_PERMISSION = {
  SUPER_WRITE: "SUPER_WRITE",
  WRITE: "WRITE",
  READ: "READ"
};

export const DATE_HOURS_MINUTE_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DATE_HOURS_MINUTE_FORMAT = "DD/MM/YYYY HH:mm";

export const DATE_FORMAT = "DD/MM/YYYY";

export const checkSpecialChar = (_, value) => {
  let specials = /[!@#$%^&*()~`]/;
  if (specials.test(value)) {
    return Promise.reject(new Error("Không được nhập kí tự đặc biệt."));
  }
  return Promise.resolve();
};

export const checkSpecialCharQR = (_, value) => {
  let specials = /[!@#$%^&*()~`]/;
  if (specials.test(value)) {
    return Promise.reject(new Error("Mã xác thực không hợp lệ."));
  }
  return Promise.resolve();
};

export const checkIsNotNumber = (_, value) => {
  const regex = new RegExp(/^\d+$/);
  if (!isEmpty(value) && !regex.test(value)) {
    return Promise.reject(new Error("Vui lòng nhập số."));
  }
  return Promise.resolve();
};

export const checkSpecialCharAndWhiteSpace = (_, value) => {
  const regex = /^([A-Za-z0-9_-]+)$/;
  if (regex.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(
    new Error("Không được nhập kí tự đặc biệt và khoảng trắng.")
  );
};
